import Vue from "vue";

import { loadData } from "@/api/loadData";
import pjson from "../package.json";
import router from "./router";
import store from "./store";

import App from "./App.vue";

import "@/styles/styles.scss";

console.log(pjson.version);
Vue.config.productionTip = false;
loadData();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
